module.exports = __webpack_public_path__ + "static/img/info2.9431a128.jpg";